// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HYVT","footer":"styles_footer__ctuxj","passCodeTooltip":"styles_passCodeTooltip__1xT-5"};